import React, { useState, useEffect, useRef }  from 'react';
import Constants from 'components/show_drawing/Constants.jsx';
import { GetRequest } from 'components/common/index.js';
import { AddWindowsPopup, OptionPresets, InternalDimensionsChooser, DimensionTextsIncludedChooser, BoundingBoxDimensionTextsIncludedChooser } from 'components/show_drawing/redraw_form/index.js';
import renderOption from 'components/show_drawing/redraw_form/options/renderOption.jsx';
import ToolTip from 'components/show_drawing/ToolTip.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'

const DrawingOptions = ({ id, drawing, unit, register, errors, optionsUserChanged, addToOptionsUserChanged, removeFromOptionsUserChanged, debug, setMaxHeight, setRedrawRequested, customerAddOnsEnabled, GetRequestPath, currentDrawingOptions, addAddOnToDieline, removeAddOnFromDieline, addOnsAsQueryStr, advancedOptionsVisible, setAdvancedOptionsVisible, advancedOptionsHidden, hasGuestAdvancedOptions, dimensionTextschecked, setDimensionTextschecked, isAdmin, boundingBoxDimensionTextsIncluded, setBoundingBoxDimensionTextsIncluded}) => {
  const [options, setOptions] = useState([])
  const [advancedOptions, setAdvancedOptions] = useState([])
  const [addWindowsVisible, setAddWindowsVisible] = useState(false);

  const fetchOptions = () => {
    // https://diecuttemplates.com.dev/drawing-options/0/en/72606/in
    GetRequest({
      url: `/drawing-options/0/${window.locale}/${id}/${unit}`,
      callback: (data) => {
        setOptions( () => data.values )
        fetchAdvancedOptions();
      }
    })
  }

  const fetchAdvancedOptions = () => {
    // https://diecuttemplates.com.dev/drawing-options/1/en/72606/in
    GetRequest({
      url: `/drawing-options/1/${window.locale}/${id}/${unit}`,
      callback: (data) => {
        setAdvancedOptions( () => data.values )
      }
    })
  }

  const calculateMaxHeight = () => {
    let h = $("#optionsCol").height();
    setMaxHeight( () => `${h}px` );
  }

  const DispatchOptionsUpdated = () => { emitEvent(Constants.options_updated, id)  }

  // Each leaf option component picks its own grid-column class on its
  // outer .row div (booleans default to half-width, every other input type
  // and long-labelled booleans add .booleanGridItemWide). Hidden options
  // short-circuit before that div even exists, so they don't claim a grid
  // cell. The map below can therefore call getOption directly with no
  // intermediate wrapper — fixing the runtime-visibility regression where
  // a length input unhidden by a sibling boolean (e.g. Overflow → V4 on
  // becf-10803) ended up squashed into half a cell.
  const getOption = (option, labelGroup = 'dimensions') => (
    renderOption({
      id,
      drawing,
      option,
      unit,
      optionsUserChanged,
      addToOptionsUserChanged,
      setRedrawRequested,
      labelGroup
    })
  )

  const internalDimensions = () => {
    if(!drawing.show_internal_dimensions) { return }
    return <InternalDimensionsChooser id={id} unit={unit} drawing={drawing} setRedrawRequested={setRedrawRequested} />
  }

  const removeAdvancedOptionsFromOptionsUserChanged = () => {
    advancedOptions.map(removeFromOptionsUserChanged);
  }

  const showAdvancedOptionsWithoutRedraw = (e) => {
    e?.preventDefault();
    calculateMaxHeight();
    setAdvancedOptionsVisible( () => true )
  }

  const showAdvancedOptions = (e) => {
    showAdvancedOptionsWithoutRedraw(e)
    setRedrawRequested( () => true)
  }

  const hideAdvancedOptions = (e) => {
    e.preventDefault();
    setAdvancedOptionsVisible( () => false )
    removeAdvancedOptionsFromOptionsUserChanged()
    setRedrawRequested( () => true)
  }

  const currentAddOnCount = () => {
    if(currentDrawingOptions == undefined) { return 0 }
    if(currentDrawingOptions["add_ons"] == undefined) { return 0 }

    return currentDrawingOptions["add_ons"].length;
  }

  const [onRecoverySetValueMsgReceived, setonRecoverySetValueMsgReceived] = useState(false);

  const onRecoverySetValueMsg = (msg) => {
    if (msg.detail.id != id) { return; }
    const rule = msg.detail.rule;
    if ((rule.recovery_apply_to || []).some((recovery) => recovery.advanced) && !advancedOptionsVisible) {
      showAdvancedOptionsWithoutRedraw();
    }
  }

  const onRulesAndFormulaOptionsDoNotMatchMsg = (msg) => {
    if (msg.detail.id != id) { return; }

    showAdvancedOptionsWithoutRedraw();
  }

  const optionPresets = () => {
    if(drawing.option_presets == undefined || drawing.option_presets.length == 0) { return }

    return <OptionPresets id={id} drawing={drawing} unit={unit} setRedrawRequested={setRedrawRequested} />
  }

  const onAbcLinesReady = () => {
    if( $("#svg_abc_education").length) {
      var panZoomInstanceAbc = svgPanZoom('#svg_abc_education', {
        zoomEnabled: false,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        minZoom: 0.5,
        maxZoom: 5.2,
        panEnabled: true,
        contain: true
      })
      $(".dmt2").hide();
      $(".abc2").show();
      $(".abc2").css("opacity", 1);
      panZoomInstanceAbc.zoom(0.95);
    } else {
      setTimeout(onAbcLinesReady, 100);
    }
  }

  // useEffect starts
  useEffect(DispatchOptionsUpdated, [options, advancedOptions])
  useEffect(fetchOptions, [id, unit]);

  MyEventListener([
    {
      key: Constants.drawing_recovery_set_value_required,
      callback: onRecoverySetValueMsg
    },
    {
      key: Constants.drawing_rules_and_formula_options_do_not_match,
      callback: onRulesAndFormulaOptionsDoNotMatchMsg
    }
  ])

  return (
    <>
      {debug && <>[{id}]</>}

      { optionPresets() }

      { internalDimensions() }

      {options.length > 0 && (
        <div style={{textAlign: 'right', paddingRight: '5px', lineHeight: 1}}>
          <ToolTip title={drawing.abc_lines_help_text} toolTipKey={`abc_lines_${id}`} onReady={onAbcLinesReady} />
        </div>
      )}

      <div className={styles.booleanGrid}>
        {options.map(getOption)}

        <DimensionTextsIncludedChooser
          id={id}
          drawing={drawing}
          unit={unit}
          dimensionTextschecked={dimensionTextschecked}
          setDimensionTextschecked={setDimensionTextschecked}
        />

        {isAdmin && (
          <BoundingBoxDimensionTextsIncludedChooser
            boundingBoxDimensionTextsIncluded={boundingBoxDimensionTextsIncluded}
            setBoundingBoxDimensionTextsIncluded={setBoundingBoxDimensionTextsIncluded}
            setRedrawRequested={setRedrawRequested}
          />
        )}
      </div>

      { customerAddOnsEnabled && <div className={styles.optionLink}> <span key="2">
            <a href="#" onClick={ (e) => {  e.preventDefault(); setAddWindowsVisible( () => true) } }>
              <i className="zmdi zmdi-plus-square"></i> &nbsp;
              { currentAddOnCount() == 0 && t('drawing.show_add_ons_window') }
              { currentAddOnCount() > 0 && <> {t('drawing.show_add_ons_window_add_remove')} ({currentAddOnCount()}) </> }
            </a>
          </span>
        </div>
      }

      { !advancedOptionsHidden && (advancedOptions.length > 0 || hasGuestAdvancedOptions) && !advancedOptionsVisible && <div className={`${styles.row} ${styles.optionLink}`}> <span key="1" className={`input-group-addon input-group-addon-${window.locale} ${styles.input_add_on_for_technical_props}`}>
          <a href="#" onClick={showAdvancedOptions} className="btn simple-btn dieline-outline-btn"> <i className="fa fa-gears"> </i> &nbsp; { t('drawing.show_advanced_options') } </a>
        </span> </div>
      }

      { !advancedOptionsHidden && (advancedOptions.length > 0 || hasGuestAdvancedOptions) && advancedOptionsVisible && <div className={`${styles.row} ${styles.optionLink}`}> <span key="0" className={`input-group-addon input-group-addon-${window.locale} ${styles.input_add_on_for_technical_props}`}>
          <a href="#" onClick={hideAdvancedOptions} className="btn simple-btn dieline-outline-btn" > <i className="fa fa-gears"> </i>  &nbsp; { t('drawing.hide_advanced_options') } </a>
        </span> </div>
      }

      { !advancedOptionsHidden && advancedOptionsVisible && (
        <div className={styles.booleanGrid}>
          {advancedOptions.map((option) => getOption(option, 'advanced'))}
        </div>
      ) }

      {customerAddOnsEnabled && <AddWindowsPopup
        id={id}
        unit={unit}
        addWindowsVisible={addWindowsVisible}
        setAddWindowsVisible={setAddWindowsVisible}
        GetRequestPath={GetRequestPath}
        currentDrawingOptions={currentDrawingOptions}
        optionsUserChanged={optionsUserChanged}
        addToOptionsUserChanged={addToOptionsUserChanged}
        addAddOnToDieline={addAddOnToDieline}
        removeAddOnFromDieline={removeAddOnFromDieline}
        addOnsAsQueryStr={addOnsAsQueryStr}
      /> }
    </>
  )
}

export default DrawingOptions;
